export default "__VITE_ASSET__065c8b41__"